import IconIntegration from '../../assets/img/icons/vr.svg';
import IconCustomApproach from '../../assets/img/icons/help.svg';
import IconResults from '../../assets/img/icons/results.svg';
import IconSafety from '../../assets/img/icons/safe.svg';
import IconIntuitive from '../../assets/img/icons/360.svg';
import { useTranslation } from 'react-i18next';

const Why = () => {
    const { t } = useTranslation();

    const features = [
        {
            icon: IconIntegration,
            title: t('why.items.item1.title'),
            description: t('why.items.item1.description'),
            className: "",
        },
        {
            icon: IconCustomApproach,
            title: t('why.items.item2.title'),
            description: t('why.items.item2.description'),
            className: "md:row-span-2 xl:row-span-1",
        },
        {
            icon: IconResults,
            title: t('why.items.item3.title'),
            description: t('why.items.item3.description'),
            className: "",
        },
        {
            icon: IconSafety,
            title: t('why.items.item4.title'),
            description: t('why.items.item4.description'),
            className: "",
        },
        {
            icon: IconIntuitive,
            title: t('why.items.item5.title'),
            description: t('why.items.item5.description'),
            className: "",
        },
    ];

    return (
        <div id='proc-vrpad' className="py-20 mx-auto text-center" style={{ maxWidth: "var(--width-container)" }}>
            <h2 className="text-3xl font-bold mb-12">
                {t('why.title')} <span className="text-primary">{t('why.highlight')}</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className={`bg-[#E8FCFF] p-10 rounded-2xl flex flex-col justify-center items-center text-left gap-5 transition-all hover:scale-105 ${feature.className}`}
                    >
                        <img src={feature.icon} alt={feature.title} className="w-14 h-14 mb-5" />

                        <h3 className="text-2xl font-medium">
                            {feature.title}
                        </h3>

                        <p>{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Why;
